
// import { useState, useEffect, useContext } from "react";
// import MainLayouts from "../../Layout/MainLayouts";
// import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
// import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
// import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
// import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
// import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
// import Spinner from "../spinner/Spinner";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import ApiServices from "../../api/ApiServices";
// import { toast } from "react-toastify";
// import DataTable from "react-data-table-component";
// import Swal from "sweetalert2";
// import CustomStyles from "../../components/utils/CustomStyles";
// import { handleError } from "../../components/utils/AuthenticationCheck";
// import { AuthContext } from "../../AuthProvider/AuthProvider";

// const RiderList = () => {
//   const [riders, setRiders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filterText, setFilterText] = useState("");
//   const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
//   const { permissions } = useContext(AuthContext);

//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchAllProperties = async () => {
//       setLoading(true);
//       try {
//         const authData = JSON.parse(localStorage.getItem("auth"));
//         const token = authData?.token;
//         if (!token) {
//           throw new Error("No access token found.");
//         }

//         const response = await axios.get(ApiServices.getAllRiders, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           withCredentials: true,
//         });


//         // console.log("these are all the  riders", response.data);
//         const { status, message, data } = response.data;
//         if (status === 200) {
//           setRiders(data);
//           toast.success(message, { toastId: "riders-fetch-success" });
//         } else {
//           handleError({ response: { status, data: { message } } }, navigate);
//         }
//       } catch (error) {
//         handleError(error, navigate);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAllProperties();
//   }, []);

//   const handleFilter = (e) => {
//     setFilterText(e.target.value);
//     setResetPaginationToggle(!resetPaginationToggle);
//   };



//   // Define Expandable Component for Actions
//   const ExpandableComponent = ({ data }) => (
//     <div className="flex justify-start p-4 relative">
//       {permissions.some(permission => permission.name === 'rider.view') && (
//         <Link
//           to="/admin/riders/details"
//           state={{ riders: data }}
//           className="mx-2 group"
//         >
//           <Eye className="w-5 h-5 text-darkGreen3" />
//           <div className="absolute ml-4 top-full left-2/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
//             View Rider
//           </div>
//         </Link>
//       )}
//       {permissions.some(permission => permission.name === 'rider.edit') && (
//         <Link
//           to="/admin/riders/update"
//           state={{ riders: data }}
//           className="mx-2 group"
//         >
//           <PencilSquare className="w-5 h-5 text-dash4" />
//           <div className="absolute ml-4 top-full left-2/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
//             Update Rider
//           </div>
//         </Link>
//       )}
//     </div>
//   );

//   const columns = [
//     {
//       name: "Full Name",
//       sortable: true,
//       width: "300px",
//       cell: (row) => (
//         <div>
//           <span className="block font-bold">
//             {row.firstname ? row.firstname.toUpperCase() : "NOT AVAILABLE"}{" "}
//             {row.lastname ? row.lastname.toUpperCase() : "NOT AVAILABLE"}
//           </span>
//           <span
//             className={`px-3 py-0.5 rounded-md  text-xs ${row.status.toLowerCase() === "active"
//               ? "bg-darkGreen3 text-lGrey2"
//               : "bg-dash5 text-lGrey2"
//               }`}
//           >
//             {row.status ? row.status.toLowerCase() : "NOT AVAILABLE"}
//           </span>
//         </div>
//       ),
//     },
//     {
//       name: "Bike Plate No",
//       selector: (row) => row.vehicle_plate_number.toUpperCase(),
//       sortable: true,
//       width: "200px",
//     },
//     {
//       name: "Email",
//       selector: (row) => row.email,
//       sortable: true,
//       width: "300px",
//     },

//     {
//       name: "Phone",
//       selector: (row) => row.phone_number,
//       sortable: true,
//       width: "120px",
//     },


//   ];


//   const filteredItems = riders.filter((item) => {
//     for (let key in item) {
//       if (
//         typeof item[key] === "string" &&
//         item[key].toLowerCase().includes(filterText.toLowerCase())
//       ) {
//         return true;
//       }
//     }
//     return false;
//   });

//   const data = filteredItems.map((riders) => ({
//     firstname: riders.firstname ? riders.firstname : "NOT AVAILABLE",
//     lastname: riders.lastname ? riders.lastname : "NOT AVAILABLE",
//     status: riders.status ? riders.status : "NOT AVAILABLE",
//     email: riders.email ? riders.email : "NOT AVAILABLE",
//     phone_number: riders.phone_number ? riders.phone_number : "NOT AVAILABLE",
//     vehicle_plate_number: riders.vehicle_plate_number ? riders.vehicle_plate_number.toUpperCase() : "NOT AVAILABLE",
//     rider_id: riders.rider_id,
//     created_at: riders.created_at
//   }));

//   // Sort data based on creation date
//   const sortedData = [...data].sort((a, b) => {
//     const dateA = new Date(a.created_at);
//     const dateB = new Date(b.created_at);
//     return dateB - dateA;
//   });

//   return (
//     <div>
//       <MainLayouts>
//         <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
//           <section
//             className="w-full pr-[3%] pt-3 my-3"
//             style={{ backgroundColor: "#F7F7F7" }}
//           >
//             <nav className="bg-gray-200 py-0 px-4 rounded-lg">
//               <ol className="list-none p-0 inline-flex mb-2">
//                 <li className="flex items-center">
//                   <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                     Riders
//                   </p>
//                   <ChevronRightIcon />
//                 </li>
//                 <li className="flex items-center">
//                   <p className="text-orange1">List</p>
//                 </li>
//               </ol>
//             </nav>
//           </section>
//           <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between">
//             <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
//               <input
//                 type="search"
//                 className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
//                 placeholder="Search"
//                 value={filterText}
//                 onChange={handleFilter}
//               />
//             </div>


//           </div>
//           {loading ? (
//             <Spinner loading={loading} />
//           ) : (

//             <DataTable
//               columns={columns}
//               data={sortedData}
//               pagination
//               striped
//               highlightOnHover
//               customStyles={CustomStyles}
//               noDataComponent={<div>No Riders found</div>}
//               expandableRows
//               expandableRowsComponent={ExpandableComponent}
//             />
//           )}
//         </div>
//       </MainLayouts>
//     </div>
//   );
// };

// export default RiderList;



import { useState, useEffect, useContext } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as ChevronDown } from "bootstrap-icons/icons/chevron-down.svg";
import { ReactComponent as XCircle } from "bootstrap-icons/icons/x-circle.svg";
import { ReactComponent as Download } from "bootstrap-icons/icons/download.svg";
import { ReactComponent as Search } from "bootstrap-icons/icons/search.svg";
import { ReactComponent as ArrowClockwise } from "bootstrap-icons/icons/arrow-clockwise.svg";
import Spinner from "../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../components/utils/CustomStyles";
import { handleError } from "../../components/utils/AuthenticationCheck";
import { AuthContext } from "../../AuthProvider/AuthProvider";
import { downloadCSVFromApi } from "../../components/utils/DownlaodCSVFromApi";
import formatDate from "../../components/utils/DateFormatter";

const RiderList = () => {
  const [riders, setRiders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingCSV, setLoadingCSV] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const { permissions } = useContext(AuthContext);

  // Date filter state
  const [filters, setFilters] = useState({
    start_date: "",
    end_date: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    const fetchAllProperties = async () => {
      setLoading(true);
      try {
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) {
          throw new Error("No access token found.");
        }

        const response = await axios.get(ApiServices.getAllRiders, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const { status, message, data } = response.data;
        if (status === 200) {
          setRiders(data);
          toast.success(message, { toastId: "riders-fetch-success" });
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setLoading(false);
      }
    };

    fetchAllProperties();
  }, [navigate]);

  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  // Handle filter changes
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  // Check if both dates are selected
  const areDatesSelected = filters.start_date && filters.end_date;

  // Handle status selection
  const handleStatusSelect = (status) => {
    setSelectedStatus(status);
    setIsDropdownOpen(false);
  };

  // Handle CSV Download
  const handleDownloadCSV = async () => {
    if (!areDatesSelected) {
      toast.error("Please select both start and end dates to download CSV");
      return;
    }

    // Validate date range
    const startDate = new Date(filters.start_date);
    const endDate = new Date(filters.end_date);

    if (startDate > endDate) {
      toast.error("Start date must be before end date");
      return;
    }

    // limit date range to a year
    const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
    if (daysDiff > 365) {
      toast.error("Date range cannot exceed 1 year");
      return;
    }

    setLoadingCSV(true);

    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;

      if (!token) {
        toast.error("No access token found");
        return;
      }

      // Prepare download payload
      const downloadPayload = {
        start_date: filters.start_date,
        end_date: filters.end_date,
        download: 1,
      };

      // Create filename with date range
      const startDateFormatted = filters.start_date.replace(/-/g, '_');
      const endDateFormatted = filters.end_date.replace(/-/g, '_');
      const filename = `riders_${startDateFormatted}_to_${endDateFormatted}.csv`;

      // Call the download function
      await downloadCSVFromApi(
        ApiServices.getAllRiders,
        downloadPayload,
        token,
        {
          filename: filename,
          columnsToRemove: [], // Add sensitive columns to exclude 
          maxRows: 50000,
          navigate: navigate,
        }
      );

    } catch (error) {
      console.error("Download error:", error);
      handleError(error, navigate);
      // Additional download-specific error messages
      if (error.message && error.message.includes("CSV")) {
        toast.error("Failed to process CSV file");
      } else if (error.message && error.message.includes("network")) {
        toast.error("Network error during download");
      }
    } finally {
      setLoadingCSV(false);
    }
  };

  // Clear date filters
  const handleClearDates = () => {
    setFilters({
      start_date: "",
      end_date: "",
    });
    toast.success("Date filters cleared");
  };

  // Define Expandable Component for Actions
  const ExpandableComponent = ({ data }) => (
    <div className="flex justify-start p-4 relative">
      {permissions.some(permission => permission.name === 'rider.view') && (
        <Link
          to="/admin/riders/details"
          state={{ riders: data }}
          className="mx-2 group"
        >
          <Eye className="w-5 h-5 text-darkGreen3" />
          <div className="absolute ml-4 top-full left-2/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
            View Rider
          </div>
        </Link>
      )}
      {permissions.some(permission => permission.name === 'rider.edit') && (
        <Link
          to="/admin/riders/update"
          state={{ riders: data }}
          className="mx-2 group"
        >
          <PencilSquare className="w-5 h-5 text-dash4" />
          <div className="absolute ml-4 top-full left-2/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
            Update Rider
          </div>
        </Link>
      )}
    </div>
  );

  const columns = [
    {
      name: "Full Name",
      sortable: true,
      width: "300px",
      cell: (row) => (
        <div>
          <span className="block font-bold">
            {row.firstname ? row.firstname.toUpperCase() : "NOT AVAILABLE"}{" "}
            {row.lastname ? row.lastname.toUpperCase() : "NOT AVAILABLE"}
          </span>
          <span
            className={`px-3 py-0.5 rounded-md  text-xs ${row.status.toLowerCase() === "active"
              ? "bg-darkGreen3 text-lGrey2"
              : "bg-dash5 text-lGrey2"
              }`}
          >
            {row.status ? row.status.toLowerCase() : "NOT AVAILABLE"}
          </span>
        </div>
      ),
    },
    {
      name: "Bike Plate No",
      selector: (row) => row.vehicle_plate_number ? row.vehicle_plate_number.toUpperCase() : "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
    {
      name: "Email",
      selector: (row) => row.email ? row.email : "NOT AVAILABLE",
      sortable: true,
      width: "300px",
    },
    {
      name: "Phone",
      selector: (row) => row.phone_number ? row.phone_number : "NOT AVAILABLE",
      sortable: true,
      width: "120px",
    },
    {
      name: "Date",
      selector: (row) => row.created_at ? formatDate(row.created_at) : "Not Available",
      sortable: true,
      width: "200px",
    },
  ];

  // Filter data based on search text, status, AND date range
  const filteredItems = riders.filter((item) => {
    const matchesFilterText = Object.values(item).some(
      (value) =>
        typeof value === "string" &&
        value.toLowerCase().includes(filterText.toLowerCase())
    );

    // Filter data based on selected status
    const matchesStatus =
      !selectedStatus ||
      item.status.toLowerCase() === selectedStatus.toLowerCase();

    // Filter data based on date range
    let matchesDateRange = true;
    if (areDatesSelected && item.created_at) {
      const itemDate = new Date(item.created_at);
      const startDate = new Date(filters.start_date);
      const endDate = new Date(filters.end_date);

      // Set time to end of day for end date
      endDate.setHours(23, 59, 59, 999);

      matchesDateRange = itemDate >= startDate && itemDate <= endDate;
    }

    return matchesFilterText && matchesStatus && matchesDateRange;
  });

  const data = filteredItems.map((riders) => ({
    created_at: riders.created_at,
    firstname: riders.firstname ? riders.firstname : "NOT AVAILABLE",
    lastname: riders.lastname ? riders.lastname : "NOT AVAILABLE",
    status: riders.status ? riders.status : "NOT AVAILABLE",
    email: riders.email ? riders.email : "NOT AVAILABLE",
    phone_number: riders.phone_number ? riders.phone_number : "NOT AVAILABLE",
    vehicle_plate_number: riders.vehicle_plate_number ? riders.vehicle_plate_number.toUpperCase() : "NOT AVAILABLE",
    rider_id: riders.rider_id,
  }));

  // Sort data based on creation date
  const sortedData = [...data].sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA;
  });

  return (
    <div>
      <MainLayouts>
        <div className="sm:rounded-lg py-6 w-full">
          <section
            className="w-full pl-[3%] pr-[3%] pt-3 my-3"
            style={{ backgroundColor: "#F7F7F7" }}
          >
            <nav className="bg-gray-200 py-0 px-4 rounded-lg ">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Riders
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-orange1 ">List</p>
                </li>
              </ol>
            </nav>
          </section>

          {/* Filter Controls Section - Responsive - Same as Customer */}
          <div className="pb-4 bg-white dark:bg-gray-900">
            {/* DESKTOP FILTERS (md and up) - All in one row */}
            <div className="hidden md:flex flex-wrap items-center gap-3">
              {/* Search Input Field with Icon */}
              <div className="relative flex-grow min-w-[200px]">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="search"
                    className="block w-full pl-10 pr-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    placeholder="Search ..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </div>

              {/* Status Dropdown */}
              <div className="relative min-w-[180px]">
                <div>
                  <button
                    type="button"
                    className="bg-darkGreen3 inline-flex w-full justify-between items-center rounded-md px-3 py-2.5 text-sm font-semibold text-dGrey3"
                    id="menu-button"
                    aria-expanded={isDropdownOpen}
                    aria-haspopup="true"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  >
                    <span className="truncate">
                      {selectedStatus || "Status"}
                    </span>
                    <ChevronDown className="w-4 h-4 text-gray-400" />
                  </button>
                </div>
                {isDropdownOpen && (
                  <div
                    className="absolute right-0 z-10 mt-1 w-full origin-top-right divide-y divide-gray-100 rounded-md bg-lGrey shadow-lg ring-1 ring-black1 ring-opacity-5 focus:outline-none"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="menu-button"
                  >
                    <div
                      className="py-1 rounded-md"
                      role="none"
                      style={{ backgroundColor: "white" }}
                    >
                      <button
                        onClick={() => handleStatusSelect("active")}
                        className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                        role="menuitem"
                      >
                        Active
                      </button>
                      <button
                        onClick={() => handleStatusSelect("pending")}
                        className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                        role="menuitem"
                      >
                        Pending
                      </button>
                      <button
                        onClick={() => handleStatusSelect("blocked")}
                        className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                        role="menuitem"
                      >
                        Blocked
                      </button>
                      <button
                        type="button"
                        className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                        onClick={() => handleStatusSelect("")}
                      >
                        All Status
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Start Date Input */}
              <div className="min-w-[150px]">
                <div className="relative">
                  <input
                    type="date"
                    value={filters.start_date}
                    onChange={(e) => handleFilterChange("start_date", e.target.value)}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                    max={filters.end_date || undefined}
                    placeholder="Start Date"
                  />
                </div>
              </div>

              {/* End Date Input */}
              <div className="min-w-[150px]">
                <div className="relative">
                  <input
                    type="date"
                    value={filters.end_date}
                    onChange={(e) => handleFilterChange("end_date", e.target.value)}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                    min={filters.start_date || undefined}
                    placeholder="End Date"
                  />
                </div>
              </div>

              {/* Clear Dates Button - Only show when dates are selected */}
              {areDatesSelected && (
                <div className="min-w-[120px]">
                  <button
                    onClick={handleClearDates}
                    className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-2.5 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800 transition-colors duration-200"
                  >
                    <XCircle className="w-4 h-4" />
                    Clear Dates
                  </button>
                </div>
              )}

              {/* Download Button */}
              <div className="min-w-[160px]">
                <button
                  onClick={handleDownloadCSV}
                  className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-2.5 text-sm font-semibold transition-colors duration-200 ${areDatesSelected
                    ? "bg-orange1 text-lGrey3 hover:bg-orange-600 cursor-pointer"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                  disabled={!areDatesSelected || loadingCSV}
                  title={!areDatesSelected ? "Select start and end dates to enable download" : ""}
                >
                  {loadingCSV ? (
                    <>
                      <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
                      Downloading...
                    </>
                  ) : (
                    <>
                      <Download className="w-4 h-4" />
                      Download CSV
                    </>
                  )}
                </button>
              </div>
            </div>

            {/* MOBILE FILTERS (below md) - Stacked layout */}
            <div className="md:hidden flex flex-col gap-3">
              {/* Search - Full width on mobile */}
              <div className="w-full">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="search"
                    className="block w-full pl-10 pr-3 py-3 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
                    placeholder="Search riders..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </div>

              {/* Filters grid for mobile */}
              <div className="grid grid-cols-2 gap-3">
                {/* Status Dropdown - Full width on mobile */}
                <div className="col-span-2">
                  <div>
                    <button
                      type="button"
                      className="bg-darkGreen3 inline-flex w-full justify-between items-center rounded-md px-4 py-3 text-sm font-semibold text-dGrey3"
                      id="mobile-menu-button"
                      aria-expanded={isDropdownOpen}
                      aria-haspopup="true"
                      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    >
                      <span className="truncate">
                        {selectedStatus || "Status"}
                      </span>
                      <ChevronDown className="w-4 h-4 text-gray-400" />
                    </button>
                  </div>
                  {isDropdownOpen && (
                    <div
                      className="relative z-10 mt-1 w-full divide-y divide-gray-100 rounded-md bg-lGrey shadow-lg ring-1 ring-black1 ring-opacity-5 focus:outline-none"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="mobile-menu-button"
                    >
                      <div
                        className="py-1 rounded-md"
                        role="none"
                        style={{ backgroundColor: "white" }}
                      >
                        <button
                          onClick={() => handleStatusSelect("active")}
                          className="block w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                          role="menuitem"
                        >
                          Active
                        </button>
                        <button
                          onClick={() => handleStatusSelect("pending")}
                          className="block w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                          role="menuitem"
                        >
                          Pending
                        </button>
                        <button
                          onClick={() => handleStatusSelect("blocked")}
                          className="block w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                          role="menuitem"
                        >
                          Blocked
                        </button>
                        <button
                          type="button"
                          className="block w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                          onClick={() => handleStatusSelect("")}
                        >
                          All Status
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Start Date - Half width on mobile */}
                <div className="col-span-1">
                  <div className="relative">
                    <input
                      type="date"
                      value={filters.start_date}
                      onChange={(e) => handleFilterChange("start_date", e.target.value)}
                      className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
                      max={filters.end_date || undefined}
                      placeholder="Start"
                    />
                  </div>
                </div>

                {/* End Date - Half width on mobile */}
                <div className="col-span-1">
                  <div className="relative">
                    <input
                      type="date"
                      value={filters.end_date}
                      onChange={(e) => handleFilterChange("end_date", e.target.value)}
                      className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
                      min={filters.start_date || undefined}
                      placeholder="End"
                    />
                  </div>
                </div>

                {/* Clear Dates Button - Full width when shown */}
                {areDatesSelected && (
                  <div className="col-span-2">
                    <button
                      onClick={handleClearDates}
                      className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-3 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800"
                    >
                      <XCircle className="w-4 h-4" />
                      Clear Dates
                    </button>
                  </div>
                )}

                {/* Download Button - Full width on mobile */}
                <div className="col-span-2">
                  <button
                    onClick={handleDownloadCSV}
                    className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-3 text-sm font-semibold ${areDatesSelected
                      ? "bg-orange1 text-lGrey3 hover:bg-orange-600"
                      : "bg-gray-300 text-gray-500 cursor-not-allowed"
                      }`}
                    disabled={!areDatesSelected || loadingCSV}
                  >
                    {loadingCSV ? (
                      <>
                        <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
                        <span className="ml-2">Downloading...</span>
                      </>
                    ) : (
                      <>
                        <Download className="w-4 h-4" />
                        <span className="ml-2">Download CSV</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* DESKTOP help text (md and up) */}
            <div className="hidden md:flex items-center justify-between mt-2">
              {!areDatesSelected && (
                <p className="text-xs text-gray-500">
                  Select start and end dates to enable download
                </p>
              )}
              {areDatesSelected && sortedData.length > 0 && (
                <p className="text-sm text-gray-600">
                  Showing {sortedData.length} records from {filters.start_date} to {filters.end_date}
                </p>
              )}
            </div>

            {/* MOBILE help text (below md) */}
            <div className="md:hidden mt-3">
              {!areDatesSelected && (
                <p className="text-xs text-gray-500 text-center mb-2">
                  Select start and end dates to enable download
                </p>
              )}
              {areDatesSelected && sortedData.length > 0 && (
                <p className="text-sm text-gray-600 text-center">
                  Showing {sortedData.length} records
                </p>
              )}
            </div>
          </div>

          {/* Data Table */}
          {loading ? (
            <Spinner loading={loading} />
          ) : (
            <DataTable
              columns={columns}
              data={sortedData}
              pagination
              striped
              highlightOnHover
              customStyles={CustomStyles}
              noDataComponent={
                <div className="text-center py-8">
                  {areDatesSelected ?
                    "No riders found for the selected date range" :
                    "No riders found"
                  }
                </div>
              }
              expandableRows
              expandableRowsComponent={ExpandableComponent}
            />
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default RiderList;
